import { css } from '@linaria/core';
import TheSansC5s_4_SemiLight_greek_woff2 from '../../assets/fonts/TheSansC5s-4_SemiLight-greek.woff2';
import TheSansC5s_4_SemiLight_latin_woff2 from '../../assets/fonts/TheSansC5s-4_SemiLight-latin.woff2';
import TheSansC5s_4_SemiLight_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-4_SemiLight-latin-ext.woff2';
import TheSansC5s_4_SemiLight_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-4_SemiLight-vietnamese.woff2';
import TheSansC5s_5_Plain_greek_woff2 from '../../assets/fonts/TheSansC5s-5_Plain-greek.woff2';
import TheSansC5s_5_Plain_latin_woff2 from '../../assets/fonts/TheSansC5s-5_Plain-latin.woff2';
import TheSansC5s_5_Plain_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-5_Plain-latin-ext.woff2';
import TheSansC5s_5_Plain_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-5_Plain-vietnamese.woff2';
import TheSansC5s_5_PlainItalic_greek_woff2 from '../../assets/fonts/TheSansC5s-5_PlainItalic-greek.woff2';
import TheSansC5s_5_PlainItalic_latin_woff2 from '../../assets/fonts/TheSansC5s-5_PlainItalic-latin.woff2';
import TheSansC5s_5_PlainItalic_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-5_PlainItalic-latin-ext.woff2';
import TheSansC5s_5_PlainItalic_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-5_PlainItalic-vietnamese.woff2';
import TheSansC5s_6_SemiBold_greek_woff2 from '../../assets/fonts/TheSansC5s-6_SemiBold-greek.woff2';
import TheSansC5s_6_SemiBold_latin_woff2 from '../../assets/fonts/TheSansC5s-6_SemiBold-latin.woff2';
import TheSansC5s_6_SemiBold_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-6_SemiBold-latin-ext.woff2';
import TheSansC5s_6_SemiBold_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-6_SemiBold-vietnamese.woff2';
import TheSansC5s_7_Bold_greek_woff2 from '../../assets/fonts/TheSansC5s-7_Bold-greek.woff2';
import TheSansC5s_7_Bold_latin_woff2 from '../../assets/fonts/TheSansC5s-7_Bold-latin.woff2';
import TheSansC5s_7_Bold_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-7_Bold-latin-ext.woff2';
import TheSansC5s_7_Bold_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-7_Bold-vietnamese.woff2';
import TheSansC5s_8_ExtraBold_greek_woff2 from '../../assets/fonts/TheSansC5s-8_ExtraBold-greek.woff2';
import TheSansC5s_8_ExtraBold_latin_woff2 from '../../assets/fonts/TheSansC5s-8_ExtraBold-latin.woff2';
import TheSansC5s_8_ExtraBold_latin_ext_woff2 from '../../assets/fonts/TheSansC5s-8_ExtraBold-latin-ext.woff2';
import TheSansC5s_8_ExtraBold_vietnamese_woff2 from '../../assets/fonts/TheSansC5s-8_ExtraBold-vietnamese.woff2';
export const FontStyles = css `
	:global(html) {
		/* TheSans C5s */

		/* Semi Light, 350 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 350;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_4_SemiLight_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 350;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_4_SemiLight_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 350;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_4_SemiLight_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 350;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_4_SemiLight_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}

		/* Plain/Regular, 400 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_5_Plain_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_5_Plain_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_5_Plain_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_5_Plain_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}

		/* Plain/Regular Italic, 400 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: italic;
			font-display: swap;
			src: url(${TheSansC5s_5_PlainItalic_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: italic;
			font-display: swap;
			src: url(${TheSansC5s_5_PlainItalic_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: italic;
			font-display: swap;
			src: url(${TheSansC5s_5_PlainItalic_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 400;
			font-style: italic;
			font-display: swap;
			src: url(${TheSansC5s_5_PlainItalic_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}

		/* Semi Bold, 600 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 600;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_6_SemiBold_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 600;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_6_SemiBold_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 600;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_6_SemiBold_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 600;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_6_SemiBold_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}

		/* Bold, 700 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 700;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_7_Bold_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 700;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_7_Bold_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 700;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_7_Bold_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 700;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_7_Bold_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}

		/* Extra Bold, 800 */
		/* ↳ greek */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 800;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_8_ExtraBold_greek_woff2}) format('woff2');
			unicode-range: U+0370-03FF;
		}
		/* ↳ latin */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 800;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_8_ExtraBold_latin_woff2}) format('woff2');
			unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
				U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
		}
		/* ↳ latin-ext */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 800;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_8_ExtraBold_latin_ext_woff2}) format('woff2');
			unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
				U+A720-A7FF;
		}
		/* ↳ vietnamese */
		@font-face {
			font-family: 'TheSans C5s';
			font-weight: 800;
			font-style: normal;
			font-display: swap;
			src: url(${TheSansC5s_8_ExtraBold_vietnamese_woff2}) format('woff2');
			unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9,
				U+20AB;
		}
	}
`;
export default FontStyles;
